module.exports = function(phone){
  const phoneRegex = /^(?:\+?(\d{1,3})[-.\s]?)?(?:\(?(\d{3})\)?[-.\s]?)(\d{3})[-.\s]?(\d{4})$/;
  const match = phoneRegex.exec(phone);
  if(!match) return false;
  return true;
}
